import React from 'react'
import Seo from '../Seo/Seo'
import { LuBrain, LuGlobe } from 'react-icons/lu'
import { FaRegHandshake } from 'react-icons/fa'

const About = () => {
  return (
    <>
      <Seo
        title='About | Bridging education and industry | CLI'
        description='CLI partners with leading industries to deliver programs that reflect current trends and real-world challenges, so graduates step into the workforce with confidence.'
        path='/about'
      />
      <header className='page_hero'>
        <span className='home_eyebrow'>About us</span>
        <h1>Bridging the gap between education and industry</h1>
        <p className='home_lead'>
          We partner with leading industries to develop and deliver programs that reflect current trends, emerging technologies and real-world challenges, so graduates can step into the workforce with confidence.
        </p>
      </header>

      <div className='page_body'>
        <div className='bento'>
          <div className='bento_card'>
            <LuBrain className='bento_icon' />
            <h3 className='bento_title'>Innovative curriculum</h3>
            <p className='bento_para'>Dynamic, engaging content that incorporates cutting-edge technologies and teaching methodologies.</p>
          </div>
          <div className='bento_card tone-brand'>
            <FaRegHandshake className='bento_icon' />
            <h3 className='bento_title'>Industry partnerships</h3>
            <p className='bento_para'>Curriculum alignment, mentorship and industry exposure through collaboration with leading industries.</p>
          </div>
          <div className='bento_card'>
            <LuGlobe className='bento_icon' />
            <h3 className='bento_title'>Global outlook</h3>
            <p className='bento_para'>Programs designed to stay relevant across geographies and cultural contexts.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
